export default __webpack_public_path__ + "static/media/Africa_Cup.4e9145cf.png";